import React, { useEffect } from "react";
import { useCalcularTotal } from "./../../../../Shared/Hooks/Custom.hooks";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Productos.component.scss";

const ProductosComponent = ({ productos = [], modificarCarrito, eliminarArticulo }) => {
  const [productosTotal, setProductos] = useCalcularTotal(productos);

  useEffect(() => {
    setProductos(productos);
  }, [productos]);

  const handleSumarClick = (producto) => {
    const cantidadFinal = parseInt(producto.Cantidad) + 1;
    producto.Cantidad = cantidadFinal;
    
    modificarCarrito(producto);
  };

  const handleRestarClick = (producto) => {

    const cantidadFinal = parseInt(producto.Cantidad) - 1;

    if (cantidadFinal <= 0) {
      return;
    }

    producto.Cantidad = cantidadFinal;
    modificarCarrito(producto);
  };

  const handleEliminarClick = (producto) => {
    eliminarArticulo(producto)
  };

  return (
    <div className="Productos">
      <div className="Productos__Cabecera">
        <div className="Productos__Cabecera--Descripcion">
          <span>Producto</span>
        </div>
        <div className="Productos__Cabecera--Precio">
          <span>Precio</span>
        </div>
        <div className="Productos__Cabecera--Cantidad">
          <span>Cantidad</span>
        </div>
        <div className="Productos__Cabecera--Total">
          <span>Total</span>
        </div>
        <div className="Productos__Cabecera--Eliminar"></div>
      </div>
      {productosTotal.map((producto, index) => {
        return (
          <div className="Productos__Detalles" key={index}>
            <div className="Productos__Detalles--Descripcion">
              <span>{producto.Descripcion}</span>
            </div>
            <div className="Productos__Detalles--Precio">
              <span>{producto.Precio_Formateado}</span>
            </div>
            <div className="Productos__Detalles--Cantidad">
              <Button
                variant="primary"
                size="sm"
                onClick={() => {
                  handleRestarClick(producto);
                }}
              >
                -
              </Button>
              <span>{producto.Cantidad}</span>
              <Button
                variant="primary"
                size="sm"
                onClick={() => {
                  handleSumarClick(producto);
                }}
              >
                +
              </Button>
            </div>
            <div className="Productos__Detalles--Total">
              <span>{producto.Total}</span>
            </div>
            <div className="Productos__Detalles--Eliminar">
              <Button
                variant="outline-danger"
                size="sm"
                onClick={() => {
                  handleEliminarClick(producto);
                }}
              >
                <FontAwesomeIcon icon={["fas", "trash-alt"]} />
              </Button>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ProductosComponent;
